export const defaultCaptchaModelData = {
  passed: false,
  modalRendered: false
};

export const ActionType = {
  RENDER_MODAL: `render_modal`,
  DESTROY_MODAL: `destroy_modal`,
};

export const MODAL_MAIN_CLASS = `captcha-modal-wrapper`;
